import React from 'react';
import { X } from 'lucide-react';
import { useModalOpen } from '../../utils/modalLock';

// Окно для нового кода: по центру на десктопе, нижний лист на телефоне, боковая панель (side="right").
// Доступность (role=dialog, фокус, Tab, Esc, возврат фокуса) обеспечивает utils/dialogA11y для любого окна, включая это.
// Панель на стекле, поля внутри на непрозрачных поверхностях.
const SIZE = { sm: 'sm:max-w-sm', md: 'sm:max-w-lg', lg: 'sm:max-w-2xl', xl: 'sm:max-w-4xl' };

function ModalInner({ title, onClose, size = 'md', side, footer, children, closeLabel = 'Закрыть' }) {
  useModalOpen();
  const panel = side === 'right'
    ? 'ml-auto h-full w-full sm:max-w-md rounded-none sm:rounded-l-3xl animate-slide-in-r'
    : `w-full ${SIZE[size] || SIZE.md} max-h-[92dvh] sm:max-h-[86dvh] rounded-t-3xl sm:rounded-3xl animate-sheet-up sm:animate-pop-in`;
  return (
    <div className={`fixed inset-0 z-[80] flex ${side === 'right' ? 'justify-end' : 'items-end sm:items-center justify-center sm:p-4'}`}>
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className={`relative glass-strong flex flex-col shadow-pop ${panel}`}>
        {side !== 'right' && <div className="sm:hidden mx-auto mt-2 h-1 w-10 rounded-full bg-surface-200" aria-hidden="true" />}
        {title && (
          <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-surface-200 shrink-0">
            <h2 className="font-semibold text-ink truncate" data-dialog-title>{title}</h2>
            <button type="button" onClick={onClose} aria-label={closeLabel} className="p-1.5 rounded-lg text-ink-tertiary hover:bg-surface-100 hover:text-ink"><X className="w-4 h-4" /></button>
          </div>
        )}
        <div className="flex-1 min-h-0 overflow-y-auto px-5 py-4">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-surface-200 shrink-0 flex flex-wrap justify-end gap-2 safe-bottom">{footer}</div>}
      </div>
    </div>
  );
}

export default function Modal({ open = true, ...props }) {
  return open ? <ModalInner {...props} /> : null;
}
